<div class="drawer-container">
  <div class="drawer-header">
    <h2>AI Assessment Result</h2>
    <div class="header-actions">
      <button mat-icon-button (click)="toggleRawJson()" matTooltip="Toggle Raw JSON">
        <mat-icon>code</mat-icon>
      </button>
      <button mat-icon-button (click)="copyToClipboard()" matTooltip="Copy JSON">
        <mat-icon>content_copy</mat-icon>
      </button>
      <button mat-icon-button (click)="close()" matTooltip="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  @if (!rawJsonView) {
<div class="drawer-content">
    @if (parseError) {
<div class="error-message">
      <mat-icon>error</mat-icon>
      <span>{{ parseError }}</span>
    </div>
}

    @if (parsedResult && !parseError) {
<div>
      <!-- Summary Section -->
      <mat-card class="summary-card">
        <mat-card-header>
          <mat-card-title>Summary</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="summary-grid">
            <div class="summary-item">
              <label>Application:</label>
              <span>{{ parsedResult.applicationName || appName }}</span>
            </div>
            <div class="summary-item">
              <label>Repository:</label>
              <span>{{ parsedResult.repositoryName }}</span>
            </div>
            <div class="summary-item">
              <label>Total Score:</label>
              <span class="score-badge" [ngClass]="getScoreClass(parsedResult.totalScore)">
                {{ parsedResult.totalScore }}
              </span>
            </div>
            <div class="summary-item">
              <label>Modernization Value Index:</label>
              <span>{{ parsedResult.modernizationValueIndex | number: '1.2-2' }}</span>
            </div>
            <div class="summary-item">
              <label>Estimated Savings:</label>
              <span class="savings">{{ formatCurrency(parsedResult.estimatedSavingsUsd) }}</span>
            </div>
            <div class="summary-item full-width">
              <label>Value Message:</label>
              <p class="value-message">{{ parsedResult.valueMessage }}</p>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Category Scores Section -->
      <mat-card class="category-card">
        <mat-card-header>
          <mat-card-title>Category Scores</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="category-grid">
            <div class="category-item">
              <label>Operational Efficiency:</label>
              <span>{{ parsedResult.categoryScores.operationalEfficiencyScore | number: '1.2-2' }}</span>
            </div>
            <div class="category-item">
              <label>Technical Agility:</label>
              <span>{{ parsedResult.categoryScores.technicalAgilityScore | number: '1.2-2' }}</span>
            </div>
            <div class="category-item">
              <label>Cloud Optimization:</label>
              <span>{{ parsedResult.categoryScores.cloudOptimizationScore | number: '1.2-2' }}</span>
            </div>
            <div class="category-item">
              <label>Security & Compliance:</label>
              <span>{{ parsedResult.categoryScores.securityComplianceScore | number: '1.2-2' }}</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Dimensions Section -->
      <mat-accordion>
        @for (dim of getDimensionArray(); track dim) {
<mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ dim.key }}
            </mat-panel-title>
            <mat-panel-description>
              <span class="dimension-score" [ngClass]="getScoreClass(dim.value.score)">
                Score: {{ dim.value.score }}
              </span>
              <span class="dimension-size" [ngClass]="getSizeClass(dim.value.size)">
                {{ dim.value.size }}
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="dimension-content">
            <p><strong>Reasoning:</strong></p>
            <p class="reasoning-text">{{ dim.value.reasoning }}</p>
          </div>
        </mat-expansion-panel>
}
      </mat-accordion>
    </div>
}
  </div>
}

  <!-- Raw JSON View -->
  @if (rawJsonView) {
<div class="drawer-content raw-json">
    <pre>{{ resultJson }}</pre>
  </div>
}
</div>
